export enum TransacoesEnum {
	ANALISAR_RECURSO = 'AD_ANALISAR_RECURSO',
	DASH_BOARD_GESTOR = 'AD_DASHBOARD_GESTOR',
	MANTER_CAD = 'AD_MANTER_MEMBRO_CAD',
	ESTAGIO_PROBATORIO_GESTOR = 'AD_ESTAGIO_PROBATORIO_GESTOR_DISABLED',
	AVALIACAO_INSTITUCIONAL_GESTOR = 'AD_AVALIACAO_INSTITUCIONAL_GESTOR',
	MONITORACAO_RESULTADO = 'AD_MONITORACAO_RESULTADO_GESTOR',
	DASH_ESTAGIO_PROBATORIO_OPERACIONAL = 'AD_DASH_ESTAGIO_PROBATORIO_OPERACIONAL',
	AD_EP_CAD_COMMON = 'AD_MANTER_MEMBRO_CAD_V2',
	AD_EP_ANALISE_RECURSO = 'AD_ANALISAR_RECURSO_V2'
}
